import { createSelector } from 'reselect';

import { StoreState } from '..';

export const reviewAndEditSelector = (state: StoreState) => state.reviewAndEdit;

export const setEditedPogSelector = ((state: StoreState) => state?.api?.setResizedPog?.status === 'FETCHING');

export const productImagesShownSelector = createSelector(
  reviewAndEditSelector,
  reviewAndEdit => reviewAndEdit.isProductImagesShown,
);

export const skuNumberShownSelector = createSelector(
  reviewAndEditSelector,
  reviewAndEdit => reviewAndEdit.isSkuNumberShown,
);

export const visualizerAlertSelector = createSelector(
  reviewAndEditSelector,
  reviewAndEdit => reviewAndEdit.visualizerAlert,
);

export const isAlertOpenedSelector = createSelector(
  reviewAndEditSelector,
  reviewAndEdit => reviewAndEdit.isAlertOpened,
);

export const displayAlertsIndicatorSelector = createSelector(
  reviewAndEditSelector,
  reviewAndEdit => reviewAndEdit.displayAlertsIndicator,
);

export const isToggleAlertSelector = createSelector(
  reviewAndEditSelector,
  reviewAndEdit => reviewAndEdit.isToggleAlert,
);

export const isStrikeZoneEnabledSelector = createSelector(
  reviewAndEditSelector,
  reviewAndEdit => reviewAndEdit.isStrikeZoneEnabled,
);

export const isPogHeightEnabledSelector = createSelector(
  reviewAndEditSelector,
  reviewAndEdit => reviewAndEdit.isPogHeightEnabled,
);

export const selectedFacingEntitiesSelector = createSelector(
  reviewAndEditSelector,
  reviewAndEdit => reviewAndEdit.selectedFacingEntities,
);

export const pdfExportStatusSelector = createSelector(
  reviewAndEditSelector,
  reviewAndEdit => reviewAndEdit.pdfExportStatus,
);

export const PEGxExportLoadingSelector = createSelector(
  reviewAndEditSelector,
  reviewAndEdit => reviewAndEdit.PEGxExportLoading,
);
